document.querySelectorAll('.ApartmentsListTableAS').forEach((el) => {
    handle();
    setActive();

    function handle() {
        const other = el.querySelector('.ApartmentsListTableAS__other');
        if (other) {
            other.addEventListener('click', () => {
                fetch(other.dataset.url)
                    .then((r) => r.text())
                    .then((html) => {
                        other.outerHTML = html
                        handle();
                        setTimeout(setActive, 100);
                    });
            });
        }
    }

    function setActive() {
        el.querySelectorAll('.ApartmentsListTableAS__item').forEach((el) => {
            el.dataset.init = '1';
        })
    }
})
